import axios from "axios";
import * as utils from "./utils";
import { Reset } from "./dispatch";

const API_URL = utils.API_URL;
// axios interceptor request to setup token in header
axios.interceptors.request.use(async (config: any) => {
  const storedUser = localStorage.getItem("user");
  let user = null;
  let isCustomer = false;

  if (storedUser) {
    try {
      user = JSON.parse(storedUser);
      isCustomer = user?.role?.name?.toLowerCase() === "customer";
    } catch (e) {
      console.error("Failed to parse user from localStorage", e);
    }
  }

  config.baseURL = API_URL;
  config.headers = {
    ...config.headers,
    "Api-Key": utils?.API_KEY ? utils?.API_KEY : "",
    ...(isCustomer && { "x-user-type": "client" }),
    Accept: "application/json",
    // "X-Requested-With": "XMLHttpRequest",
    "Accept-Language": "en",
    "Access-Control-Allow-Origin": "*",
  };

  return config;
});

//axios interceptor response to set auto logout
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (axios.isCancel(error)) {
      return Promise.reject(error);
    }
    if (error.message === "Network Error") {
      error.response = {
        status: 500,
        data: {
          message: "Network Error | Network Unavailable",
        },
      };
    }
    // if(error?.response?.status == 403){
    //   console.log(error,"403403403403403403403")
    // }

    if (error.response.status === 401) {
      // let result: any = responseDataFormate(error?.response?.data);
      // let errMsg = error?.response?.data?.msg
      //   ? error?.response?.data?.msg
      //   : error?.response?.data?.message
      //     ? error?.response?.data?.message
      //     : error?.response?.data?.error
      //       ? error?.response?.data?.error
      //       : result?.message
      //         ? result?.message
      //         : "Unauthorized";

      // error.response = {
      //   status: 401,
      //   data: {
      //     message: errMsg,
      //   },
      // };
      Reset();
    }
    if (error.response.status === 500) {
      if (!error.response.data || !error.response.data.message) {
        error.response = {
          status: 500,
          data: {
            message: "Something went wrong",
          },
        };
      }
    }
    return Promise.reject(error);
  }
);

export default axios;
